import { Button, HStack, useToast, VStack, Text, Checkbox, Box, Collapse, Flex } from "@chakra-ui/react";
import ModalSelectMonth from "./modal_select_month";
import ModalSelectMonthOld from "./modal_select_month_old";
import ModalSelectStaffYears from "../modal_select_staff_years";

import SelectSection from "../select_section";
import ModalSelectCompanies from "./modal_select_companies";
import SelectLeads from "./select_leads";

import ModalSelectManagers from "../modal_select_managers";
import baseUrl from "../../vars";
import { authFetch } from "../../auth/auth";
import { observer } from "mobx-react-lite";
import { useStores } from "../../store/store_context";
import { useEffect, useState, useRef } from "react";
import SelectTypeProfit from "./select_type_profit";
import SelectGroupBy from "../select_group_by";
import SelectBackup from "../select_backups";
import SelectBind from "../select_bind";


const FiltersGrid = observer(({ renderButtons }) => {
  const { pageStore } = useStores();
  const [isLoading, setIsLoading] = useState(false);

  const toast = useToast();
  const [requestTime, setRequestTime] = useState(0);
  const [isTimerActive, setIsTimerActive] = useState(false);
  const timerRef = useRef(null);

  const handleCancel = () => {
    if (pageStore.abortControllerRef) {
      pageStore.abortControllerRef.abort();
      console.log('Нажата кнопка отмены');
    }
  };

  const startTimer = () => {
    setIsTimerActive(true);
    const startTime = Date.now();
    setRequestTime(0);
    pageStore.setRequestTime(0);

    if (timerRef.current) clearInterval(timerRef.current);

    timerRef.current = setInterval(() => {
      setRequestTime((Date.now() - startTime) / 1000);
      pageStore.setRequestTime((Date.now() - startTime) / 1000);
    }, 50);
  };

  const stopTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
    setIsTimerActive(false);
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  const getAllProfits = async () => {
    setIsLoading(true);
    startTimer();
    pageStore.abortControllerRef = new AbortController();
    const { signal } = pageStore.abortControllerRef;
    pageStore.setLoading(true)
    pageStore.clearDataProfit();
    let page = 0;
    const count = 500;
    let total = 0;

    try {
      const query = new URLSearchParams();

      if (pageStore.selected_period_month?.length > 0) {
        pageStore.selected_period_month?.forEach((month) => {
          query.append("months", month);
        });
      }

      if (pageStore.selected_period_years?.length > 0) {
        pageStore.selected_period_years?.forEach((year) => {
          query.append("years", year);
        });
      }

      if (pageStore.selected_managers && pageStore.selected_managers !== "") {
        pageStore.selected_managers.forEach((manager) => {
          query.append("managers", manager);
        });
      }

      if (pageStore.selected_one_department != "") {
        query.append("departament", pageStore.selected_one_department);
      }

      if (pageStore.select_one_company != "") {
        query.append("PromotionCompanies", pageStore.select_one_company);
      }

      if (pageStore.selected_type_leads != "") {
        query.append("leadType", pageStore.selected_type_leads);
      }

      if (pageStore.month_and_year_fromB24) {
        query.append("month_and_year_fromB24", "true");
      }

      if (pageStore.month_and_year_fromProfit) {
        query.append("month_and_year_fromProfit", "true");
      }

      if (pageStore.month_and_year_from1C) {
        query.append("month_and_year_from1C", "true");
      }

      if (pageStore.selected_staff_years) {
        query.append("staff_year", pageStore.selected_staff_years)
      }

      query.append("page", page);
      query.append("count", count);

      const response = await authFetch(`${baseUrl}/api/profit/?${query}`, {
        method: "GET",
        signal: signal,
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${pageStore.token}`,
        },
      });
      const result = await response.json();

      const data = result?.data || [];
      if (page == 0) total = result?.total || 0;
      pageStore.addDataProfit(data);
    } catch (err) {
      toast({
        title: "Ошибка загрузки потенциалов",
        description: err.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      pageStore.AbortControllerRef = null;
      setIsLoading(false);
      stopTimer();
      pageStore.setLoading(false);
    }
  };

  const buttons = (
    <>
      <Button
        isLoading={isLoading}
        onClick={async () => await getAllProfits()}
        bg="#333"
        color="white"
        w={{ base: "100%", md: "15vw" }}
        _hover={{
          background: "#444",
        }}
        mr={3}
      >
        Сформировать
      </Button>
      <Button
        onClick={() => pageStore.resetProfitFilters()}
        bg="#333"
        color="white"
        w={{ base: "100%", md: "15vw" }}
        _hover={{
          background: "#444",
        }}
        mr={3}
      >
        Сбросить фильтры
      </Button>
      <Button
        onClick={() => handleCancel()}
        bg="#333"
        color="white"
        w={{ base: "100%", md: "15vw" }}
        _hover={{
          background: "#444",
        }}
      >
        Отменить запрос
      </Button>
    </>
  )

  return (
    <>
      <Box position="relative" w="100%">
        <VStack width="100%" align="center" px={{ base: "10px", md: "20px" }}>
          <Collapse in={pageStore.open_filter} animateOpacity style={{ width: '100%' }}>
            <Box w="100%">
              <VStack w={"100%"} gap={{ base: "20px", md: "15px" }}>

                {/* Ряд 1: Основные селекторы и чекбоксы дат */}
                <Flex
                  width="100%"
                  direction={{ base: "column", xl: "row" }} // В колонку на мобилках, в ряд только на широких экранах
                  align={{ base: "stretch", xl: "flex-start", sm: "start" }}
                  gap={4}
                  wrap="wrap"
                  justify="center"

                >
                  <ModalSelectMonthOld />

                  <VStack align="start" fontSize={"12px"}>
                    <Text color={"#EEEEEE"}>Менеджеры:</Text>
                    <ModalSelectManagers />
                  </VStack>

                  <VStack align="start" fontSize={"12px"}>
                    <Text color={"#EEEEEE"}>Рекламные кампании:</Text>
                    <ModalSelectCompanies />
                  </VStack>

                  <VStack align="start" fontSize={"12px"}>
                    <Text color={"#EEEEEE"}>Отделы:</Text>
                    <SelectSection />
                  </VStack>

                  <VStack align="start" fontSize={"12px"}>
                    <Text color={"#EEEEEE"}>Лиды:</Text>
                    <SelectLeads />
                  </VStack>

                  <VStack
                    align="start"
                    spacing={2}
                    bg="#333"
                    p={3}
                    borderRadius="10px"
                    color="#EEEEEE"
                    w={{ base: "100%", sm: "auto" }}
                    h="fit-content" // Дополнительно указываем высоту по контенту
                  >
                    <Checkbox
                      colorScheme="green"
                      isChecked={pageStore.month_and_year_fromB24}
                      onChange={(e) => pageStore.setMonthAndYearFromB24(e.target.checked)}
                      size={{ base: "sm", md: "md" }}
                    >
                      Даты из Б24
                    </Checkbox>
                    <Checkbox
                      colorScheme="green"
                      isChecked={pageStore.month_and_year_fromProfit}
                      onChange={(e) => pageStore.setMonthAndYearFromProfit(e.target.checked)}
                      size={{ base: "sm", md: "md" }}
                    >
                      Даты из Профит
                    </Checkbox>
                    <Checkbox
                      colorScheme="green"
                      isChecked={pageStore.month_and_year_from1C}
                      onChange={(e) => pageStore.setMonthAndYearFrom1C(e.target.checked)}
                      size={{ base: "sm", md: "md" }}
                    >
                      Даты из 1C
                    </Checkbox>
                  </VStack>
                </Flex>

                {/* Ряд 2: Значения, Стаж и Системные селекторы */}
                <Flex
                  width="100%"
                  direction={{ base: "column", lg: "row" }}
                  wrap="wrap"
                  justify="center"
                  align={{ base: "stretch", lg: "start", sm: "start" }}
                  gap={4}
                >
                  <VStack
                    align="start"
                    spacing={2}
                    bg="#333"
                    p={3}
                    borderRadius="10px"
                    color="#EEEEEE"
                    w={{ base: "100%", sm: "auto" }}
                    h="fit-content" // Дополнительно указываем высоту по контенту
                  >
                    <Checkbox
                      colorScheme="green"
                      isChecked={pageStore.absolute_column_profit}
                      onChange={(e) => pageStore.setAbsoluteColumnProfit(e.target.checked)}
                      size={{ base: "sm", md: "md" }}

                    >
                      Абсолютные значения
                    </Checkbox>
                    <Checkbox
                      colorScheme="green"
                      isChecked={pageStore.percent_column_profit}
                      onChange={(e) => pageStore.setPercentColumnProfit(e.target.checked)}
                      size={{ base: "sm", md: "md" }}

                    >
                      Прирост, %
                    </Checkbox>
                    <Checkbox
                      colorScheme="green"
                      isChecked={pageStore.part_column_profit}
                      onChange={(e) => pageStore.setPartColumnProfit(e.target.checked)}
                      size={{ base: "sm", md: "md" }}

                    >
                      Доли, %
                    </Checkbox>
                  </VStack>

                  <ModalSelectStaffYears />

                  <VStack
                    align="start"
                    spacing={2}
                    bg="#333"
                    p={3}
                    borderRadius="10px"
                    color="#EEEEEE"
                    w={{ base: "100%", sm: "auto" }}
                    h="fit-content" // Дополнительно указываем высоту по контенту
                  >
                    <Checkbox
                      colorScheme="green"
                      isChecked={pageStore.workers}
                      onChange={(e) => pageStore.setWorkers(e.target.checked)}
                      size={{ base: "sm", md: "md" }}
                    >
                      Работающие
                    </Checkbox>
                  </VStack>

                  <Flex gap={2} wrap="wrap" justify="center">
                    <SelectBackup />
                    <SelectBind report_name={"profit"} />
                  </Flex>
                </Flex>

                {/* Ряд 3: Тип и Группировка */}
                <Flex
                  width="100%"
                  direction={{ base: "column", sm: "row" }}
                  justify="center"
                  gap={4}
                >
                  <SelectTypeProfit />
                  <SelectGroupBy />
                </Flex>
              </VStack>
            </Box>
          </Collapse>
        </VStack>
      </Box>

      <Collapse in={pageStore.open_filter} animateOpacity>
        {renderButtons ? renderButtons(buttons) : buttons}
      </Collapse>
    </>
  );
});

export default FiltersGrid;
